import { cn } from '@/lib/utils';

import { ctaContainerStyles, pricingCardContainerStyles } from './styles';

import { outlineClasses } from '@/decodo/blocks/PricingCards/PricingCard';
import { ButtonColors, ButtonVariants } from '@/decodo/components/atoms/Button';
import LinkButton from '@/decodo/components/atoms/LinkButton';
import RichTextFieldStrapi, {
  RichTextFieldStrapiProps,
} from '@/decodo/components/atoms/RichTextField/RichTextFieldStrapi';
import { applyToAllRTFVariants } from '@/decodo/components/atoms/RichTextField/utils';
import IconContactSales from '~/icons/message-chat-circle.svg';

export type ContactSalesProps = {
  heading?: RichTextFieldStrapiProps;
  description?: RichTextFieldStrapiProps;
  button: {
    text?: string;
    variant?: ButtonVariants;
    color?: ButtonColors;
    link: string;
  };
  outlineColor?: 'grey' | 'brand' | 'gradient';
};

export default function ContactSales({
  heading,
  description,
  button,
  outlineColor = 'gradient',
}: ContactSalesProps) {
  const trackId = `ContactUs-pricing-cards`;

  return (
    <div
      data-tracker-component='contact-card'
      className={cn(
        pricingCardContainerStyles,
        outlineColor && outlineClasses[outlineColor],
        'h-auto justify-between self-stretch'
      )}
    >
      <div className='mt-6'>
        {heading && (
          <RichTextFieldStrapi
            block={heading}
            classNames={applyToAllRTFVariants(
              'text-h2 text-center font-serif dark:text-base-dark-white'
            )}
          />
        )}

        {description && (
          <RichTextFieldStrapi
            block={description}
            classNames={applyToAllRTFVariants(
              cn(
                'text-body-m text-center dark:text-gray-dark-400',
                heading && 'mt-4'
              )
            )}
          />
        )}
      </div>

      <div
        className={cn(ctaContainerStyles, 'mt-14')}
        data-tracker-component='contact-sales'
      >
        <LinkButton
          data-tracker-context={trackId}
          variant={button.variant || 'filled'}
          color={button.color || 'secondary'}
          href={button.link}
          leftSection={<IconContactSales className='h-5 w-5' />}
          slim={false}
          fullwidth
          classNames={{
            inner: 'flex items-center justify-center gap-4',
          }}
        >
          {button?.text}
        </LinkButton>
      </div>
    </div>
  );
}
